import axios, { AxiosResponse } from 'axios'
import {
  SncrBlocosQueryResponse,
  SncrContexto,
  SncrNumeroUsado,
  SncrNumerosQueryResponse,
  SncrRetiradaDto,
  SncrRetiradaResultado,
} from './_models'

const API_URL = process.env.REACT_APP_API_URL
const SNCR_URL = `${API_URL}/sncr`

// A empresa vai como parâmetro só onde define a inscrição (vínculo); o estoque é da pessoa logada.

export const getSncrContexto = (idEmpresa: number): Promise<SncrContexto> =>
  axios
    .get(`${SNCR_URL}/contexto`, { params: { idEmpresa } })
    .then((resp: AxiosResponse<SncrContexto>) => resp.data)

/** O token gov.br vai só no corpo desta chamada; nunca é guardado no front. */
export const retirarBlocoSncr = (
  idEmpresa: number,
  dto: SncrRetiradaDto
): Promise<SncrRetiradaResultado> =>
  axios
    .post(`${SNCR_URL}/retirar`, dto, { params: { idEmpresa } })
    .then((resp: AxiosResponse<SncrRetiradaResultado>) => resp.data)

export const getSncrBlocos = (idEmpresa: number, query: string): Promise<SncrBlocosQueryResponse> =>
  axios
    .get(`${SNCR_URL}/blocos?idEmpresa=${idEmpresa}&${query}`)
    .then((resp: AxiosResponse<SncrBlocosQueryResponse>) => resp.data)

export const getSncrNumerosDoBloco = (
  idBloco: number,
  query: string
): Promise<SncrNumerosQueryResponse> =>
  axios
    .get(`${SNCR_URL}/blocos/${idBloco}/numeros?${query}`)
    .then((resp: AxiosResponse<SncrNumerosQueryResponse>) => resp.data)

/** 404 quando o número não existe ou é de outro prescritor. */
export const localizarNumeroSncr = (numero: string): Promise<SncrNumeroUsado> =>
  axios
    .get(`${SNCR_URL}/numeros`, { params: { numero } })
    .then((resp: AxiosResponse<SncrNumeroUsado>) => resp.data)
